module.exports = __webpack_public_path__ + "static/media/MetaMask.92c2163c.png";